import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TokenService } from "src/app/auth/token.service";
import { Area } from "../Models/read/Area";
import { SessionService } from "../../core/survey/shared/services/session.service";
import { AreaService } from "../services/area.service";

@Component({
  selector: "app-area-selector",
  templateUrl: "./area-selector.component.html",
  styleUrls: ["./area-selector.component.scss"],
})
export class AreaSelectorComponent implements OnInit, OnDestroy {
  @Output() blockUpdated = new EventEmitter<Area>();
  @Output() fiberhoodUpdated = new EventEmitter<Area>();

  cities: string[] = [];
  fiberHoodList: Area[] = [];
  blockList: Area[] = [];

  selectedCity: string = null;
  selectedFiberHood: Area = null;
  selectedBlock: Area = null;

  constructor(
    public tokenService: TokenService,
    private sessionService: SessionService,
    private areaService: AreaService
  ) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit() {
    this.selectedCity = sessionStorage.getItem("city");
    this.selectedFiberHood = this.sessionService.getFiberhood();
    this.selectedBlock = this.sessionService.getBlock();

    this.getCityList();
    if (!this.selectedCity) return;

    this.getFiberHoodList();
    if (!this.selectedFiberHood) return;

    this.getBlockList(this.selectedFiberHood.id);
  }

  citySelected(city: string) {
    if (city === this.selectedCity) return;

    this.selectedCity = city;
    sessionStorage.setItem("city", this.selectedCity);

    this.clearFiberhood();
    this.clearBlock();

    this.getFiberHoodList();
  }

  fiberHoodSelected(fiberHood: Area) {
    if (fiberHood.id === this.selectedFiberHood?.id) return;

    this.selectedFiberHood = fiberHood;
    sessionStorage.setItem("fiberhood", JSON.stringify(this.selectedFiberHood));
    this.fiberhoodUpdated.emit(fiberHood);

    this.clearBlock();
    this.getBlockList(this.selectedFiberHood.id);
  }

  blockSelected(block: Area) {
    if (block.id === this.selectedBlock?.id) return;
    this.selectedBlock = block;

    sessionStorage.setItem("block", JSON.stringify(this.selectedBlock));
    this.blockUpdated.emit(this.selectedBlock);
  }

  getCityList() {
    this.areaService
      .getCityNames()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: string[]) => {
        this.cities = res;
      });
  }

  getFiberHoodList() {
    this.areaService
      .getFiberHoodsForCityName(this.selectedCity)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: Area[]) => {
        this.fiberHoodList = res;
      });
  }

  getBlockList(parentId: string) {
    this.areaService
      .getBlocksForFiberHoodId(parentId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: Area[]) => {
        this.blockList = res;
      });
  }

  private clearFiberhood(): void {
    this.selectedFiberHood = null;
    sessionStorage.removeItem("fiberhood");
    this.fiberhoodUpdated.emit(null);
  }

  private clearBlock(): void {
    this.selectedBlock = null;
    sessionStorage.removeItem("block");
    this.blockUpdated.emit(null);
  }
}
